<template>
  <div class="temp-save">
    <!-- 一時保存ボタン -->
    <div>
      <md-button
        @click="onClicked"
      >
        一時保存
      </md-button>
    </div>

    <!-- 確認モーダル -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="onOpened"
      @md-closed="onClosed"
      :md-active.sync="showConfirm"
      md-title=""
      md-content="<strong>編集中の内容を一時保存しますか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="handleConfirm"
    />
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin';

export default {
  name: 'TempSave',
  mixins: [Mixin],
  data: () => ({
    showConfirm: false,
  }),
  methods: {
    handleConfirm() {
      this.$emit('save')
      this.showConfirm = false
    },
    onClicked() {
      this.$emit('click')
      this.showConfirm = true
    },
    onOpened() {
      this.scroll('locked')
    },
    onClosed() {
      this.scroll('clear')
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.temp-save
  button
    background: $baseBlueColor !important
    color: white !important
    height: 90px;
    width: 90px;
    font-size: 18px;
    border-radius: 10px !important;
    pointer-events: auto
  position: sticky
  z-index: 100
  bottom: 100px
  text-align: right
  margin-right: -150px
  pointer-events: none
  @include sp
    bottom: 100px
    margin-right: 0px
    text-align: left
    button
      height: 80px;
      width: 60px;
      font-size: 14px;
      border-radius: 5px !important;
  </style>




// WEBPACK FOOTER //
// src/components/order/TempSave.vue